import { render, staticRenderFns } from "./FormsValidation.vue?vue&type=template&id=6429e65c"
import script from "./FormsValidation.vue?vue&type=script&lang=js"
export * from "./FormsValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports